import { render } from "./FormCreateTeacher.vue?vue&type=template&id=7e82d3b0&scoped=true"
import script from "./FormCreateTeacher.vue?vue&type=script&lang=js"
export * from "./FormCreateTeacher.vue?vue&type=script&lang=js"

import "./FormCreateTeacher.vue?vue&type=style&index=0&id=7e82d3b0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue-soft/vue-soft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e82d3b0"]])

export default __exports__